import productListReducer, {
    ToolkitProductListActions,
} from "@store/Framework/Store/Toolkit/Pages/ProductList/ProductListReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    productList: productListReducer,
};

export type ToolkitPagesActions = ToolkitProductListActions;
export default combineReducers(pagesReducers);
